import { useContext } from 'react'
import { AuthContext } from '../context/Auth/AuthContext'

export const useUserPermissions = () => {
  const {
    user: { permissions, areaSelected },
  } = useContext(AuthContext)
  const getPermissionsByArea = (): boolean =>
    permissions!.filter((permission) => permission.path.startsWith(areaSelected!)).length > 0

  const getPermissionsByAreaAndModule = (module: string): boolean => {
    return (
      permissions!.filter(
        (permission) =>
          permission.path.startsWith(areaSelected!) && permission.path.includes(module),
      ).length > 0
    )
  }

  return {
    getPermissionsByArea,
    getPermissionsByAreaAndModule,
  }
}
